import React from 'react';
import Tile from '../../Tile';
import styled from "styled-components";
import FlexContainer from '../../FlexContainer';
import richot from '../../../static/img/richot.png'
import kenora from '../../../static/img/kenora.png'
import toronto from '../../../static/img/toronto.png'
import winnipeg from '../../../static/img/winnipeg.png'
import steinbach from '../../../static/img/steinbach.png'
import east_st_paul from '../../../static/img/east_st_paul.png'
import winnipeg_pano from '../../../static/img/winnipeg_pano.png'

const CitiesSection = styled.div`
  h3 {
    font-family: Roboto;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    color: #E5E5E5;
  }
`

const Cities = () => (
  <CitiesSection>
    <h3>Featured Cities</h3>
    <FlexContainer>
      <Tile title="Winnipeg, MB" bg={winnipeg}>
        <p className="category">November 22, 2025</p>
      </Tile>
      <Tile title="Toronto, ON" bg={toronto}>
        <p className="category">May 10, 2024</p>
      </Tile>
      <Tile title="Kenora, ON" bg={kenora}>
        <p className="category">September 26, 2025</p>
      </Tile>
      <Tile title="Winnipeg, MB" bg={winnipeg_pano}>
        <p className="category">October 10, 2025</p>
      </Tile>
      <Tile title="Richot, MB" bg={richot}>
        <p className="category">October 23, 2023</p>
      </Tile>
      <Tile title="East St. Paul, MB" bg={east_st_paul}>        
        <p className="category">May 12, 2021</p>
      </Tile>
      <Tile title="Steinbach, MB" bg={steinbach}>
        <p className="category">October 24, 2025</p>        
      </Tile>
    </FlexContainer>
  </CitiesSection>
)

export default Cities;